"use client";
// Shadcn

import { X } from "lucide-react";
import { useOnborda } from "onborda";
import { useCallback } from "react";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import * as m from "@/paraglide/messages";
import { completeTour } from "@/services/controllers/user";

import type { CardComponentProps } from "onborda";

export const CustomCard = ({
  step,
  currentStep,
  totalSteps,
  nextStep,
  prevStep,
  arrow,
}: CardComponentProps) => {
  const { closeOnborda, currentTour } = useOnborda();

  const onFinishTour = useCallback(() => {
    closeOnborda();
    completeTour(currentTour as any);
  }, [closeOnborda, currentTour]);

  return (
    <Card className=" p-0 w-[280px] shadow-lg">
      <CardHeader className="flex-row p-6 items-start justify-between space-y-0 pb-2 relative">
        <div className="space-y-1">
          <div className="flex items-center gap-1 font-medium">
            <span>{step.icon}</span>
            <span>{step.title}</span>
          </div>
          <p className="text-sm text-muted-foreground">
            {currentStep + 1} of {totalSteps}
          </p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 absolute right-1 top-1"
          onClick={onFinishTour}
        >
          <X className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent className="px-6 pb-4">
        <p className="text-sm">{step.content}</p>
      </CardContent>
      <CardFooter>
        <div className="flex justify-between w-full gap-4">
          {currentStep !== 0 && (
            <Button variant="outline" size="sm" onClick={() => prevStep()}>
              {m.previous()}
            </Button>
          )}
          {currentStep + 1 !== totalSteps && (
            <Button variant="default" size="sm" onClick={() => nextStep()}>
              {m.next()}
            </Button>
          )}
          {currentStep + 1 === totalSteps && (
            <Button variant="default" size="sm" onClick={onFinishTour}>
              <span>🎉</span>
              <span className="ml-2">{m.finish()}</span>
            </Button>
          )}
        </div>
      </CardFooter>
      <span className="text-background">{arrow}</span>
    </Card>
  );
};
